<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <div class="tinto-aviso">
      <fa-icon icon="info-circle" class="mr-2" />
      Saldo e créditos do cliente. O <strong>disponível</strong> vem do espelho sincronizado do ERP;
      <strong>reservado</strong> e <strong>confirmado</strong> vêm das reservas feitas pela plataforma.
      Clique num crédito para ver os registros dele na auditoria.
    </div>

    <!-- ===== BUSCA ===== -->
    <div class="tinto-filters">
      <div class="tinto-filtros__linha">
        <div class="tinto-filtros__busca">
          <input
            class="form-control"
            v-model="clienteId"
            placeholder="Código do cliente..."
            @keyup.enter="buscar()"
          />
        </div>
        <div class="tinto-filtros__acoes">
          <button class="button button-primary button--icone" @click="buscar()" title="Buscar">
            <fa-icon icon="search" />
          </button>
        </div>
      </div>
    </div>

    <template v-if="consultou">
      <!-- ===== SALDOS ===== -->
      <div class="extrato-cards">
        <div class="extrato-card">
          <div class="extrato-card__rotulo">Disponível (espelho do ERP)</div>
          <div class="extrato-card__valor extrato-card__valor--positivo">{{ formatMoney(saldos.disponivel) }}</div>
        </div>
        <div class="extrato-card">
          <div class="extrato-card__rotulo">Reservado (em aberto)</div>
          <div class="extrato-card__valor extrato-card__valor--atencao">{{ formatMoney(saldos.reservado) }}</div>
        </div>
        <div class="extrato-card">
          <div class="extrato-card__rotulo">Confirmado em pedidos</div>
          <div class="extrato-card__valor">{{ formatMoney(saldos.confirmado) }}</div>
        </div>
      </div>

      <!-- ===== CRÉDITOS ===== -->
      <div class="tinto-table-wrap">
        <table class="tinto-table">
          <thead><tr>
            <th style="width:120px">Crédito</th>
            <th style="width:110px">Lançamento</th>
            <th style="width:90px">Filial</th>
            <th style="width:120px">Valor</th>
            <th style="width:110px">Posição</th>
            <th style="width:120px">Pedido ERP</th>
            <th>Histórico</th>
          </tr></thead>
          <tbody>
            <tr v-if="creditos.length === 0">
              <td colspan="7" class="tinto-table__empty">
                Nenhum crédito no espelho local para este cliente
              </td>
            </tr>
            <tr
              v-for="credito in creditos"
              :key="credito.id"
              class="clickable"
              title="Ver os registros deste crédito na auditoria"
              @click="$emit('ver-auditoria', credito.id)"
            >
              <td class="tinto-table__primary">{{ credito.id }}</td>
              <td>{{ credito.dt_lancamento | date }}</td>
              <td>{{ credito.filial_id || '—' }}</td>
              <td>{{ formatMoney(credito.valor_credito) }}</td>
              <td>
                <span :class="['tinto-badge', credito.posicao === 'ABERTO' ? 'tinto-badge--success' : 'tinto-badge--muted']">
                  {{ credito.posicao === 'ABERTO' ? 'Aberto' : 'Utilizado' }}
                </span>
              </td>
              <td>{{ credito.pedidoerp_id || '—' }}</td>
              <td>
                <span v-if="credito.historico">{{ credito.historico }}</span>
                <span v-else class="tinto-table__muted">—</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { get } from "@/helpers/apiRequest";
import { formatMoney } from "./helpers";

export default {
  name: "creditos-clientes-extrato",
  components: { Loading },

  data() {
    return {
      clienteId: "",
      loading: false,
      consultou: false,
      saldos: { disponivel: 0, reservado: 0, confirmado: 0 },
      creditos: [],
    };
  },

  methods: {
    buscar() {
      const clienteId = String(this.clienteId || "").trim();

      if (!clienteId) return;

      this.loading = true;

      get(`/admin/creditos-clientes/${encodeURIComponent(clienteId)}/extrato`)
        .then((json) => {
          this.saldos = json.saldos || { disponivel: 0, reservado: 0, confirmado: 0 };
          this.creditos = json.creditos || [];
          this.consultou = true;
        })
        .catch((error) => {
          this.$swal({
            title: "Erro ao buscar o extrato",
            text: error.message,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    formatMoney,
  },
};
</script>

<style scoped>
/* Cards de saldo na mesma família visual do tintometrico.css. */
.extrato-cards {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.extrato-card {
  flex: 1 1 200px;
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  padding: 14px 16px;
}

.extrato-card__rotulo {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #667085;
  margin-bottom: 4px;
}

.extrato-card__valor {
  font-size: 21px;
  font-weight: 600;
  color: #101828;
}

.extrato-card__valor--positivo { color: #027a48; }
.extrato-card__valor--atencao  { color: #b54708; }
</style>
